import React, { useState, useEffect } from 'react'
import { FlexboxGrid, Icon, List, Loader, Message, Modal } from 'rsuite'
import AppContext from '../../context/AppContext'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { isEmpty } from 'lodash-es'
import { doneLoading, startLoading } from '../../utils/loading'
import {
  checkAiEvaluationStatus,
  getPerposalWordFile,
  sendAiEvaluationByFile,
} from '../../redux/actions/aiEvaluation'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'

export default function AIEvaluationProcessWidget({
  start,
  updateProcess = () => {},
  setEvaluationResultSchema = () => {},
}) {
  const { theme } = React.useContext(AppContext)
  const currentTheme = Array.isArray(theme) ? theme[0] : theme
  const isDark = currentTheme === 'dark'

  const steps = [
    { stepId: 1, stepName: 'Step 1. สร้างเอกสารสำหรับประเมิน' },
    { stepId: 2, stepName: 'Step 2. ส่งประเมิน' },
    { stepId: 3, stepName: 'Step 3. รอผลประเมิน' },
  ]

  const colors = {
    errorBg: isDark ? '#3b1c1c' : '#ffebee',
    loadingRowBg: isDark ? '#3c3f43' : '#f2fffb',
  }

  const [schema, setShema] = useState()
  const [isIntervalGetEvaluation, setIsIntervalGetEvaluation] = useState()

  const [processStep2, setProcessStep2] = useState()

  const [evalStep, setEvalStep] = useState(0)
  const [evalOpen, setEvalOpen] = useState()
  const [evalStepErrorMsg, setEvalStepErrorMsg] = useState()

  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (start) {
      handleProposalEvaluationStep1()
    }
  }, [start])

  useEffect(() => {
    if (isIntervalGetEvaluation) {
      IntervalCheckEvaluation()
    }
  }, [isIntervalGetEvaluation])

  useEffect(() => {
    if (processStep2) {
      handleProposalEvaluationStep2(processStep2)
    }
  }, [processStep2])

  const handleProposalEvaluationStep1 = async () => {
    // ป้องกันการกดซ้ำขณะที่ระบบกำลังทำงานอยู่
    if (evalStep > 0 && evalStep < 4) return

    startLoading()
    setEvalStepErrorMsg('')
    setEvalStep(1)
    setEvalOpen(true)
    setProcessStep2('')
    // await new Promise((resolve) => setTimeout(resolve, 1000))

    try {
      const blobFile = await getPerposalWordFile(projectId)

      // เช็กว่าสร้างไฟล์สำเร็จหรือไม่
      if (blobFile) {
        setProcessStep2(blobFile)
        //handleProposalEvaluationStep2(1, blobFile)
      } else {
        setEvalStepErrorMsg('สร้างไฟล์ Word ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    } catch (e) {
      setEvalStepErrorMsg('สร้างไฟล์ Word ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
    }
    doneLoading()
  }

  const handleProposalEvaluationStep2 = async (blobFile) => {
    // ป้องกันการข้าม Step
    if (evalStep != 1) return

    startLoading()
    setEvalStep(2)

    try {
      const formData = new FormData()
      formData.append('file', blobFile)

      const response = await sendAiEvaluationByFile(projectId, formData)

      if (response) {
        setProcessStep2('')
        if (evalOpen) {
          setShema(response)
          if (!isEmpty(response.statusMessage)) {
            setEvalStep(3)
            setIsIntervalGetEvaluation(true)
          } else {
            onCloseEvaluationProcess()
          }
        }
      } else {
        setEvalStepErrorMsg(DEFAULT_ERR_MSG)
      }
    } catch (e) {
      console.log(e)

      setEvalStepErrorMsg(DEFAULT_ERR_MSG)
    }
    doneLoading()
  }

  const IntervalCheckEvaluation = async () => {
    var intervalCheckError = 1
    while (true) {
      try {
        if (!isIntervalGetEvaluation || isEmpty(schema.statusMessage)) {
          break
        }

        const response = await checkAiEvaluationStatus(schema.id)

        if (response) {
          if (evalOpen) {
            setShema(response)
            if (isEmpty(response.statusMessage)) {
              setIsIntervalGetEvaluation(false)
              setEvaluationResultSchema(response)
              onCloseEvaluationProcess()
              // console.log('เสร็จแล้ว หยุด loop')
              break
            }
          } else {
            break
          }
        }
      } catch (err) {
        console.log(err)

        if (intervalCheckError >= 3) {
          setEvalStepErrorMsg(DEFAULT_ERR_MSG)
          setIsIntervalGetEvaluation(false)
          break
        } else {
          intervalCheckError++
        }
        // console.error('error:', err)
      }

      // รอ 20 วินาที
      await new Promise((resolve) => setTimeout(resolve, 20000))
    }
  }

  const onCloseEvaluationProcess = async (clearSchema) => {
    if (clearSchema) {
      setIsIntervalGetEvaluation(false)
      setEvaluationResultSchema('')
    }
    setEvalOpen(false)
    updateProcess(false)
    await new Promise((resolve) => setTimeout(resolve, 500))
    setEvalStep(0)
  }

  return (
    <>
      <Modal
        show={evalOpen}
        onHide={() => {
          onCloseEvaluationProcess(true)
        }}
        size="lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>
            <b>ประเมินคุณภาพข้อเสนอโครงการ</b>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: '20px' }}>
          <List bordered>
            {steps.map((item) => {
              const isCurrent = evalStep == item.stepId
              const isPassed = evalStep > item.stepId || (item.stepId == 3 && evalStep == 4)
              const isFailed = !isEmpty(evalStepErrorMsg) && isCurrent

              return (
                <List.Item
                  key={item.stepId}
                  style={{
                    backgroundColor: isCurrent ? colors.loadingRowBg : 'transparent',
                  }}
                >
                  {/* 🚩 1. ใช้ FlexboxGrid จัดเลย์เอาต์ซ้าย-ขวา แทนการใช้ div */}
                  <FlexboxGrid justify="space-between" align="middle">
                    <FlexboxGrid.Item>{item.stepName}</FlexboxGrid.Item>

                    <FlexboxGrid.Item>
                      {isFailed ? (
                        <Icon
                          icon="close-circle"
                          size="lg"
                          style={{
                            color: '#fb8a81',
                          }}
                        />
                      ) : isPassed ? (
                        <Icon
                          icon="check-circle"
                          size="lg"
                          style={{
                            color: '#2da888',
                          }}
                        />
                      ) : isCurrent ? (
                        <Loader content="กำลังดำเนินการ..." inverted={!isFailed} />
                      ) : (
                        <Icon icon="clock-o" size="lg" />
                      )}
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                  {/* {item.stepId == 3 && statusMessage && (
                    <Message
                      type="info"
                      showIcon
                      style={{ marginTop: 10 }}
                      description={statusMessage}
                    />
                  )} */}
                  {isCurrent && evalStepErrorMsg && (
                    <Message
                      type="error"
                      showIcon
                      style={{ marginTop: 10 }}
                      description={evalStepErrorMsg}
                    />
                  )}
                </List.Item>
              )
            })}
          </List>
          {evalStep == 3 && schema?.statusMessage && (
            <Message
              type="info"
              showIcon
              style={{ marginTop: 10 }}
              description={schema?.statusMessage}
            />
          )}
        </Modal.Body>

        <Modal.Footer>
          <CancelButton
            onClick={() => {
              onCloseEvaluationProcess(true)
            }}
          >
            ยกเลิก
          </CancelButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}
